import "firebase/auth";
import "firebase/firestore";
import firebase, { QuerySnapshot } from "store/firebase";

import { AnyAction, Dispatch } from "redux";
import { StoreError } from "store/errors";
import type { RootState } from "store/reducer";
import { invalidateResourceRead } from "store/util/resource-read";
import { EVENTS_ACTION_TYPES } from "./reducer";

export const ACTION_EVENTS_DELETING = "events/deleting";
export const ACTION_EVENTS_DELETE = "events/delete";
export const ACTION_EVENTS_DELETE_ERROR = "events/delete_error";
export const ACTION_EVENTS_DELETE_RESET = "events/delete_reset";

export default function deleteEvent(eventId: string) {
  return async (dispatch: Dispatch<AnyAction>, getState: () => RootState) => {
    dispatch({ type: ACTION_EVENTS_DELETING, payload: { id: eventId, deleting: true } });
    try {
      if (!eventId) {
        throw new StoreError("Event does not have an ID");
      }

      const docRef = firebase.firestore().collection("events").doc(eventId);
      const resultsRef = firebase
        .firestore()
        .collection("results")
        .doc(eventId);
      const answersRef = docRef.collection("answers");

      // Delete all answers in the subcollection (Firestore does not cascade).
      const answersSnapshot: QuerySnapshot = await answersRef.get();
      await Promise.all(
        (answersSnapshot?.docs ?? []).map((snap) => snap.ref.delete())
      );

      // Delete the results document and the event itself.
      await Promise.all([resultsRef.delete(), docRef.delete()]);

      invalidateResourceRead(getState, [EVENTS_ACTION_TYPES.startedLoading, eventId]);
      dispatch({ type: ACTION_EVENTS_DELETE, payload: eventId });
    } catch (error) {
      console.log(error);
      dispatch({ type: ACTION_EVENTS_DELETE_ERROR, payload: { id: eventId, error } });
    }
    dispatch({ type: ACTION_EVENTS_DELETING, payload: { id: eventId, deleting: false } });
  };
}

export function resetDelete() {
  return (dispatch: Dispatch<AnyAction>) => {
    dispatch({ type: ACTION_EVENTS_DELETE_RESET });
  };
}
